import React from 'react'
import styled from 'styled-components'

const DynamicLinkModalLayout = ({
  title,
  renderPortalLink,
  renderTownLink,
  flashMessage,
  onClose,
}) => (
  <React.Fragment>
    <div className="modal-background" onClick={onClose} />
    {flashMessage ? (
      <FlashMessage message={flashMessage} />
    ) : (
      <React.Fragment>
        <ContentLayout>
          <div className="column">{renderPortalLink}</div>
          <div className="column">{renderTownLink}</div>
        </ContentLayout>
      </React.Fragment>
    )}
    <button className="modal-close is-large" aria-label="close" onClick={onClose} />
  </React.Fragment>
)

const FlashMessage = ({ message, onClose }) => (
  <div className="notification is-danger">
    {onClose && <button className="delete" onClick={onClose} />}
    {message}
  </div>
)

const ContentLayout = styled.div.attrs({
  className: 'columns modal-content',
})`
  width: 100% !important;
  overflow: unset !important;
  // margin-left: 0px;
  // margin-right: 0px;
`

export default DynamicLinkModalLayout



// WEBPACK FOOTER //
// ./src/components/templates/dynamic-link/DynamicLinkModalLayout.js